import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=3e6650d0&"
import script from "./ProductsTable.vue?vue&type=script&lang=js&"
export * from "./ProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports